import React, { useMemo } from 'react'
import AppContext from 'AppContext'
import { env } from 'components/Helpers'

const FreezeList = ({ member, match, user }) => {
  const { operator: { id } } = React.useContext(AppContext)
  const token = useMemo(() => window.localStorage.getItem('auth-token'), [])

  if (!id) {
    return (
      <div className='index memberships' />
    )
  }

  return (
    <div className='membership freeze'>
      <cl-membership-freeze
        apiHost={`https://memberships.${env()}.credlock.net`}
        mountPath={`/operators/${id}/members/${member.id}/freeze`}
        operatorid={id}
        token={token}
        membershipid={member.id}
      />
    </div>
  )
}

export default FreezeList
